// components/CampaignFilters.tsx
import React from "react";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import {
	Card,
	CardBody,
	Row,
	Col,
	FormGroup,
	Label,
	Input,
	Button,
} from "reactstrap";
import { createSelectStyles } from "helpers/reactSelectLayout";

type Option = { value: string; label: string };

interface Props {
	status: string;
	search: string;
	startDate: Date | null;
	endDate: Date | null;
	statusOptions: Option[];
	onStatusChange: (v: string) => void;
	onSearchChange: (v: string) => void;
	onDateRangeChange: (s: Date | null, e: Date | null) => void;
	onReset: () => void;
}

const CampaignFilters: React.FC<Props> = ({
	status,
	search,
	startDate,
	endDate,
	statusOptions,
	onStatusChange,
	onSearchChange,
	onDateRangeChange,
	onReset,
}) => {
	const disabledReset = !status && !search.trim() && !startDate && !endDate;

	return (
		<Card className="mb-4 shadow-sm">
			<CardBody>
				{/* Center all controls vertically */}
				<Row className="gx-3 gy-2 align-items-center">
					<Col xs={12} md={3}>
						<FormGroup className="mb-0">
							<Label className="small text-muted mb-1" for="filter-status">
								Status
							</Label>
							<Select
								inputId="filter-status"
								options={statusOptions}
								styles={createSelectStyles("light")}
								value={statusOptions.find((o) => o.value === status)}
								onChange={(opt: { value: any; }) => onStatusChange(opt?.value ?? "")}
								isClearable={false}
								placeholder="All statuses"
							/>
						</FormGroup>
					</Col>

					<Col xs={12} md={4}>
						<FormGroup className="mb-0">
							<Label className="small text-muted mb-1" for="filter-search">
								Search
							</Label>
							<Input
								id="filter-search"
								type="text"
								placeholder="Name or ID…"
								value={search}
								onChange={(e) => onSearchChange(e.target.value)}
								className="form-control-rounded"
							/>
						</FormGroup>
					</Col>

					<Col xs={12} md={4}>
						<FormGroup className="mb-0">
							<Label className="small text-muted mb-1" for="filter-dates">
								Date Range
							</Label>
							<Flatpickr
								id="filter-dates"
								className="form-control"
								options={{ mode: "range", dateFormat: "d M Y" }}
								value={[startDate, endDate].filter(Boolean) as Date[]}
								onChange={(dates) =>
									onDateRangeChange(dates[0] ?? null, dates[1] ?? null)
								}
								placeholder="Select range…"
							/>
						</FormGroup>
					</Col>

					{/* Auto-width col just for the reset button, grid-fills the height */}
					<Col xs={12} md="auto" className="d-grid">
						<Button
							color="danger"
							size="sm"
							disabled={disabledReset}
							onClick={onReset}
						>
							Reset
						</Button>
					</Col>
				</Row>
			</CardBody>
		</Card>
	);
};

export default CampaignFilters;
